/**
 * Add new categories as needed to this enum for classification purposes.
 */
export enum Category {
  Bridge = 'Bridge',
  Defi = 'Defi',
  Gaming = 'Gaming',
  Infra = 'Infra',
  NFT = 'NFT',
  Social = 'Social',
  Wallet = 'Wallet',
  OnchainSummer = 'OnchainSummer',
}
